// src/app/router/guards/AdminGuard.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermission } from '@/shared/hooks/usePermission';

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const hasAdmin = usePermission('admin-tools');
  if (!hasAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
